export default "__VITE_ASSET__ClqnRp_Q__"